import { CONTRACT_PROGRESS_CONTRACT_LOAD_REQUEST } from '@app/store/actionTypes';
import { ContractProgressAction } from '@app/store/contract-progress/actions';
import Host from '@app/store/Host';

export type ContractProgressHostState = Host | null;

const initialState: ContractProgressHostState = null;

export default function reducer(
  state: ContractProgressHostState = initialState,
  action: ContractProgressAction
) {
  switch (action.type) {
    case CONTRACT_PROGRESS_CONTRACT_LOAD_REQUEST:
      return initialState;
    default:
      return state;
  }
}
